<template>

    <validation-observer ref="validationObserver" v-slot="{ invalid, errors }">

        <!-- EDITABLE VIEW -->
        <v-row no-gutters v-if="!disableEdit">

            <v-col cols="6">

                <!-- DATE OR START DATE -->
                <v-menu
                    v-model="menuStartDateModel"
                    ref="startDateMenu"
                    :close-on-content-click="false"
                    :return-value.sync="pickerStartDateModel"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    class="cursor-pointer"
                    max-width="450px"
                    min-width="290px"
                    @update:return-value="startDatePicked"
                >
                    <template v-slot:activator="{ on }">

                        <v-tooltip top color="primary" open-delay="500">
                            <template v-slot:activator="{on : tooltip}">

                                <v-text-field
                                    v-on="{ ...on, ...tooltip }"
                                    solo
                                    :value="startDateDisplay"
                                    hint="Start date"
                                    :background-color="color"
                                    :hide-details="true"
                                    readonly
                                    placeholder="Select start date"
                                    class="picker-text-field"
                                    :error-messages="errorMessages"
                                ></v-text-field>

                            </template>

                            <span>Start date</span>

                        </v-tooltip>

                    </template>

                    <validation-provider
                        name="Start date"
                        rules="required|range:end"
                        mode="passive"
                        v-slot="{ errors }">

                        <v-date-picker
                            v-model="pickerStartDateModel"
                            color="primary"
                            header-color="primary"
                            :landscape="true"
                            @click:date="$refs.startDateMenu.save(pickerStartDateModel)"
                        ></v-date-picker>

                    </validation-provider>

                </v-menu>
            </v-col>

            <v-col cols="6" class="pl-2">

                <!-- END DATE -->
                <v-menu
                    v-model="menuEndDateModel"
                    ref="endDateMenu"
                    :close-on-content-click="false"
                    :return-value.sync="pickerEndDateModel"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    max-width="450px"
                    min-width="290px"
                    @update:return-value="endDatePicked"
                >
                    <template v-slot:activator="{ on }">

                        <v-tooltip top color="primary" open-delay="500">
                            <template v-slot:activator="{on : tooltip}">

                                <v-text-field
                                    v-on="{...on, ...tooltip}"
                                    solo
                                    :value="endDateDisplay"
                                    :close-on-content-click="false"
                                    hint="End date"
                                    :background-color="color"
                                    :hide-details="true"
                                    readonly
                                    placeholder="Select date"
                                    :error-messages="errorMessages"
                                ></v-text-field>

                            </template>

                            <span>End date</span>

                        </v-tooltip>
                    </template>

                    <validation-provider
                        name="end"
                        mode="passive"
                        rules="required"
                        v-slot="{ errors }">

                        <v-date-picker
                            v-model="pickerEndDateModel"
                            :close-on-content-click="false"
                            color="primary"
                            header-color="primary"
                            :landscape="true"
                            @click:date="$refs.endDateMenu.save(pickerEndDateModel)"
                        >
                        </v-date-picker>

                    </validation-provider>

                </v-menu>
            </v-col>
        </v-row>

        <!-- NON EDITABLE VIEW -->
        <v-row no-gutters v-if="disableEdit">

            <v-col cols="12" class="ml-2">
                From
                <v-chip class="mr-2"
                        text-color="white"
                        dark small
                        label
                        color="grey darken-1">
                    {{ startDateDisplay }}
                </v-chip>
                To
                <v-chip
                    text-color="white"
                    dark small
                    label
                    color="grey darken-1">
                    {{ endDateDisplay }}
                </v-chip>
            </v-col>

        </v-row>

    </validation-observer>
</template>

<script>

import {extend} from 'vee-validate/dist/vee-validate.full';
import moment from 'moment';
import {timeDisplay} from "../../../../components/mixins/timeDisplayMixin";

export default {

    mixins: [timeDisplay],

    props: {
        value: {
            required: false,
            type: Array,
            default: () => []
        },
        disableEdit: {
            required: false,
            type: Boolean,
            default: false,
        },
        color: {
            type: String,
            required: true,
        },
    },

    watch: {
        value(value) {
            this.pickerStartDateModel = value[0];
            this.pickerEndDateModel = value[1];
        },
    },

    computed: {

        startDateDisplay() {
            if (this.pickerStartDateModel) {
                return this.formatDate(this.pickerStartDateModel);
            }
        },
        endDateDisplay() {
            if (this.pickerEndDateModel) {
                return this.formatDate(this.pickerEndDateModel);
            }
        }
    },

    data() {
        return {
            menuStartDateModel: null,
            menuEndDateModel: null,
            pickerStartDateModel: null,
            pickerEndDateModel: null,
            errorMessages: []
        }
    },

    created() {

        if (this.value && this.value.length === 2) {
            this.pickerEndDateModel = this.value[0];
            this.pickerStartDateModel = this.value[1];
        }

        extend('range', {
            validate: ((value, {other}) => {
                return moment(value).isBefore(moment(other));
            }),
            message: 'Start date must be before End date',
            params: [{name: 'other', isTarget: true}],
        });

    },

    methods: {
        startDatePicked(value) {
            this.pickerStartDateModel = value;
            this.validate();
        },
        endDatePicked(value) {
            this.pickerEndDateModel = value;
            this.validate();
        },
        validate() {
            if (this.pickerStartDateModel && this.pickerEndDateModel) {
                this.$refs.validationObserver.validate()
                    .then(isValid => {
                        if (isValid) {
                            this.errorMessages = [];
                            this.$emit('input', [this.pickerStartDateModel, this.pickerEndDateModel]);
                        } else {
                            this.errorMessages = ['Start date must be before End date!'];
                        }
                    });
            }
        },
    }
}
</script>
